import React, { useCallback, useEffect, useState } from "react";
import { Form, Select, Input } from "antd";
import CustomButton from "components/Common/buttons/CustomButton";
import { useSelector } from "react-redux";
import { DictionariesSelector } from "store/dictionaries/selectors";
import { Option } from "antd/es/mentions";
import useStoreFilters from "customHooks/useStoreFilters";
import { AUTH_USER, FILTER_PAGE, USER_ROLES, USER_TENANT_NAME } from "utils/constants";
import { filterOptions, STATUSES, validFilters } from "pages/operations/validation-task-requests/constants";
import { isEmpty, uniq } from "lodash";
import { inputPatternTitle, inputTextPattern } from "components/Common/inputs/variables";
import TSRSelect from "components/Common/components/TSRSelect";

const ValidationTaskRequestsSearch = ({ handleSearch, TSRList }) => {
  const [form] = Form.useForm();
  const { getFilters, filters } = useStoreFilters(FILTER_PAGE.VALIDATION_TASK_REQUESTS);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const {
    list: { depot },
  } = useSelector(DictionariesSelector);

  useEffect(() => {
    if (!isEmpty(filters)) {
      const filterKey = Object.keys(filters)[0];
      const type = validFilters.includes(filterKey) ? filterKey : null;
      form.setFieldsValue({
        type,
        value: filters[filterKey],
        status: filters.status,
      });
      setSelectedFilter(type);
    }
  }, []);

  const onChangeFilter = useCallback(values => {
    setSelectedFilter(values);
    form.setFieldValue("value", null);
  }, []);

  const onSearch = useCallback(values => {
    const { type, value, status } = values;
    const { pageSize } = getFilters();
    handleSearch(!!value ? { [type]: value.trim(), status, pageSize } : { status, pageSize });
  }, []);

  return (
    <div className="custom-filter">
      <Form form={form} layout="inline" onFinish={onSearch}>
        <Form.Item initialValue="Pending" name="status">
          <Select showSearch placeholder={"Select value"}>
            {STATUSES.map(item => (
              <Option key={item} value={item.split(" ").join("")}>
                {item}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="type">
          <Select showSearch onChange={onChangeFilter} placeholder="Select type" allowClear>
            {filterOptions.map(item => (
              <Option key={item.value} value={item.value}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        {selectedFilter === "customerId" && (
          <>
            <div className="filter-divider" />
            <Form.Item name="value" rules={[{ required: true, message: "Please enter value" }]}>
              <Input placeholder={"Enter value"} allowClear pattern={inputTextPattern} title={inputPatternTitle} />
            </Form.Item>
          </>
        )}

        {selectedFilter === "technician" && (
          <>
            <div className="filter-divider" />
            <Form.Item name="value" rules={[{ required: true, message: "Please select email" }]}>
              <TSRSelect
                showSearch
                initialList={TSRList}
                roles={[
                  USER_ROLES.MMT,
                  USER_ROLES.MWT,
                  USER_ROLES.DEPOT_CLERK,
                  USER_ROLES.TECHNICIANS,
                  USER_ROLES.GCR,
                  USER_ROLES.MTSR,
                  USER_ROLES.TSS,
                  USER_ROLES.WAREHOUSE,
                  USER_ROLES.MDSC,
                ]}
                depot={AUTH_USER()?.depotName}
              />
            </Form.Item>
          </>
        )}

        {selectedFilter === "depot" && (
          <Form.Item name="value">
            <Select
              showSearch
              placeholder={"Select value"}
              rules={[{ required: true, message: "Please select value" }]}
            >
              {depot[USER_TENANT_NAME()] &&
                uniq(depot[USER_TENANT_NAME()])
                  ?.sort()
                  ?.map(item => (
                    <Option key={item} value={item}>
                      {item}
                    </Option>
                  ))}
            </Select>
          </Form.Item>
        )}
        <CustomButton type="primary" htmlType="submit" size="small" text="Search" />
      </Form>
    </div>
  );
};

export default ValidationTaskRequestsSearch;
